import * as amplitude from '@amplitude/analytics-browser';

declare global {
  interface Window {
    sessionReplay: {
      plugin: (options: { sampleRate: number }) => any;
    };
  }
}

// Initialize Amplitude
export const initAmplitude = () => {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY || '', {
    defaultTracking: {
      sessions: true,
      pageViews: false,
      formInteractions: true,
      fileDownloads: true
    },
    logLevel: amplitude.Types.LogLevel.None,
    optOut: false
  });

  // Add session replay plugin if available
  if (window.sessionReplay?.plugin) {
    amplitude.add(window.sessionReplay.plugin({
      sampleRate: 1
    }));
  }
};

// Helper functions for tracking events
export const trackEvent = (eventName: string, eventProperties?: Record<string, any>) => {
  amplitude.track(eventName, eventProperties);
};

export const setUserProperties = (properties: Record<string, any>) => {
  const identify = new amplitude.Identify();
  Object.entries(properties).forEach(([key, value]) => {
    identify.set(key, value);
  });
  amplitude.identify(identify);
};

export const setUserId = (userId: string) => {
  amplitude.setUserId(userId);
};

export const resetUser = () => {
  amplitude.reset();
};

// Track page view with counter
export const trackPageView = (pageName: string) => {
  const pageCounter = (window as any).__pageCounter || 0;
  (window as any).__pageCounter = pageCounter + 1;
  
  amplitude.track('Page Viewed', {
    page_name: pageName,
    page_counter: pageCounter + 1
  });
}; 